import { prop } from 'ramda'

export const TemplateUpdateSerializer = (html, values) => {
  const newHtml = prop('htmlBody', values)
  const type = prop('type', values)

  return { type, htmlBody: newHtml }
}
